import { ICreateAreaChecklistServicosUseCase } from "../../../presentation/useCases/create/create_area_checklist_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateAreaChecklistServicosUseCase
 */

export class CreateAreaChecklistServicosUseCase implements ICreateAreaChecklistServicosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createAreaChecklistServicos(
    areas: number[] | undefined,
    checklists: number[] | undefined,
  ): Promise<void> {
    await this.repository.createAreaChecklistServicos(
      areas ?? [],
      checklists ?? [],
    );
  }
}
